import { ICustomer } from './i-api-customer'

export interface ICreditBalance {
	creditLimit: number
	reservedAmount: number
	currency: any
	transactionDate: string
	accountAgreementId: string
	availableCreditAmount: number
	balance: number
	cardExpirationDate: string
	cardAgreementId: string
	accountNumber: string
	creditCardNo: string
	cardID: number
	statusIssuer: IIMSStatusIssuer
	statusUser: IIMSStatusIssuer
	statusCardActivation: IIMSStatusIssuer
	cardAgreementOpenDate: string
	productId: string
	accountOwnerPartyId: string
	hasPPI: boolean
	ppiEligible: boolean
}

export interface IDepositData {
	accountAgreementId: string
	accountCurrency: string
	accountNumber: string
	accountOwnerPartyId: string
	balance: number
	bindingPeriod: number
	interestRate: number
	note?: string
	accountAgreementOpenDate: string
	productId: string
	agreementStatus: IMSAgreementStatus
}

export enum IMSAgreementStatus {
	InActive = 'InActive',
	Active = 'Active',
	Suspended = 'Suspended',
	Closed = 'Closed',
	Closing = 'Closing',
	Suspending = 'Suspending',
}

export interface ITransaction {
	transactionDate: string
	bookingDate: string
	currency: string
	amount: number
	invoiceAmount: number
	transactionType: string
	transactionTypeUiString: string
	description: string
	vendor: string
	billingAmount?: number
	billingCurrency?: string
	exchangeRate?: number
	creditDebit: string
	isBlockedAuthorization: boolean
	consumerClarity?: IConsumerClarity | null
}

export interface IConsumerClarity {
	recordId: string
	resultStatus: {
		code: string
		message: string
	}
	merchantResult?: {
		merchantName: string
		phone: string
		description: string
		email: string
		websiteUrl: string
		contactUrl: string
		address: {
			line: string
			city: string
			postalCode: string
			countryCode: string
			countryName: string
			countrySubdivisionCode: string
		}
		merchantCategory: {
			code: string
			description: string
		}
		logos: [
			{
				height: number
				width: number
				url: string
				type: string
				altTextTag: string
			},
		]
		merchantLocation: {
			latitude: string
			longitude: string
			type: string
		}
		dataPolicy: {
			cacheable: boolean
			cacheExpiry: string
			attribution: string
			requiredMap: string
		}
		resultStatus: {
			code: string
			message: string
		}
	}
	purchaseReceipt: {
		resultStatus: {
			code: string
			message: string
		}
		url: string
		contentType: string
		expiresOn: string
	}
	carbonFootprint: {
		carbonEmissionInGrams: number
		carbonEmissionInOunces: number
		category: {
			mainCategory: string
			subCategory: string
			sector: string
			sectorCode: string
		}
	}
	subscriptionControls: {
		recurringPayment: {
			recurringPaymentKey: {
				merchantId: string
				subscriptionId: string
			}
			frequency: string
			type: string
			supportedCancellationMethods: [string]
		}
		subscriptionState: {
			actionType: string
			subscriptionStatus: string
			createdDate: string
			updatedDate: string
			cancellationState: {
				cancellationStatusReasonCode: string
				estimatedProcessingDays: string
				cancellationMethod: string
			}
		}
	}
	searchResults: {
		resultStatus: {
			code: string
			message: string
		}
		url: string
		contentType: string
		expiresOn: string
	}
}

export interface IUnpaidInvoices {
	unpaidInvoices: IIMSInvoice[]
	numberOfInvoices: number
	totalPaymentAmount: number
	totalPaymentCurrency: Currency
}

export interface IIMSInvoice {
	periodStartDate: string
	periodEndDate: string
	paymentDueDate: string
	paymentAmount: number
	paymentCurrency: Currency
}

enum Currency {
	NOK = 0,
	EUR,
	SEK,
}

export interface IIMSStatusIssuer {
	statusIssuer: StatusIssuer
	statusIssuerNote: string
}

export enum StatusIssuer {
	Active = 'Active',
	Decline = 'Decline',
	NotActive = 'NotActive',
	//DeclineSuspectedFraud = 'DeclineSuspectedFraud',
	//DeclineRestrictedCard = 'DeclineRestrictedCard',
	//DeclineReferToCardIssuer = 'DeclineReferToCardIssuer',
	//DeclineLawViolation = 'DeclineLawViolation',
	//DeclineSuspectedCounterfeitCard = 'DeclineSuspectedCounterfeitCard',
	PickUpGeneral = 'PickUpGeneral',
	//PickUpSuspectedFraud = 'PickUpSuspectedFraud',
	//PickUpSpecialConditions = 'PickUpSpecialConditions',
	//PickUpLostCard = 'PickUpLostCard',
	//PickUpStolenCard = 'PickUpStolenCard',
	//PickUpSuspectedCounterfeitCard = 'PickUpSuspectedCounterfeitCard',
	OrderNewCard = 'OrderNewCard',
}
export interface IAccountStatement {
	accountStatementId: string
	accountStatementNumber: string
	accountStatementDate: string
	accountStatementFormat: IAccountStatementFormat
	periodStartDate: string
	periodEndDate: string
	paymentDueDate: string
	paymentDueDateSpecified: boolean
	paymentAmount: number
	paymentCurrency: string
}
export interface IAccountStatements {
	accountStatements: IAccountStatement[]
}

export enum IAccountStatementFormat {
	xml,
	pdf,
	html,
	csv,
	txtsimple,
	txt,
	xls,
	xul,
}

export interface ICardEnrollment {
	customerId: string
	cardAgreementId: number
	status: string
	phoneNo: string
	password: string
	cardHolderId: string
	label: string
}

export interface IUpdateCard {
	cardId: number
	statusIssuer?: StatusIssuer
	statusIssuerNote?: string
	statusCardActivation?: StatusCardActivation
	statusCardActivationNote?: string
	statusUser?: StatusUser
	statusUserNote?: string
	id?: string
	statusDisplayed?: string
}

export interface INewCard {
	cardAgreementId: string
	cardID: number
	id?: string
}

export enum StatusCardActivation {
	Active = 'Active',
	InActive = 'InActive',
}

export enum StatusUser {
	Active = 'Active',
	Decline = 'Decline',
}

export interface IAnnualReport {
	accountDebitBalance: number
	accountCreditBalance: number
	interestReceived: number
	interestPaid: number
	currency: string
}

export interface IAgreementHistoryDto {
	agreements: IAgreements
	customer: ICustomer
}

export interface IAgreements {
	depositAccounts: IDepositData[]
	creditCardAccounts: ICreditBalance[]
}
